import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-featured-flag',
  templateUrl: './featured-flag.component.html',
  styleUrls: ['./featured-flag.component.scss'],
  standalone: false
})
export class FeaturedFlagComponent {
  public flagHTML: string = '';
  public _featuredFlag: any = {};
  // textvalue: any;

  @Input('featuredFlag')
  set featuredFlag(val) {
    // this.flagHTML = val.textDescription.replace(/[^a-zA-Z ]/g, "").slice(0, 22);
    this.flagHTML = val.textDescription;
    // const pureTextLength = val.textDescription.replace(/\<.*?\>/g, '').length;
    // this.flagHTML = pureTextLength <= 22 ? val.textDescription : textValue;
    this._featuredFlag = val;
  }

}

